export default __webpack_public_path__ + "static/media/MrJack.2d059cd1.mp3";